<section class="loginContent">
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col col-xl-10">
        <div class="card" style="border-radius: 1rem;">
          <div class="row g-0">
            <div class="col-md-6 col-lg-5 d-none d-md-block">
              <img src="assets/login-imed.jpeg"
                   alt="login form" class="img-fluid" style="border-radius: 1rem 0 0 1rem;" />
            </div>
            <div class="col-md-6 col-lg-7 d-flex align-items-center">
              <div class="card-body p-4 p-lg-5 text-black">
                <app-formulario
                  corBotao="#6E8898"
                  guid="9f5f628b-6d4b-42d0-b3bb-8c5417e8d64d"
                  logo="logo-imed.PNG"
                  subtitulo="A solução completa e acessível para médicos."
                ></app-formulario>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
